export default "__VITE_ASSET__BYud6SA7__"